import { Pipe, PipeTransform } from "@angular/core";

@Pipe({name: 'ifNaN'})
export class IfNanPipe implements PipeTransform {
  transform(value: any): any {
    return isNaN(value) ? 0 : value;
  }
}